<template>
  <div class="the-class-roster">
    <div class="class-info-wrap">
      <div class="class-info">
        <span>
          {{ $t('public.class') }}{{ $t('public.colon') }}{{ classInfo.name }}
        </span>
        <span>
          {{ $t('public.teacher') }}{{ $t('public.colon')
          }}{{ classInfo.teacherName }}
        </span>
        <span>
          {{ $t('public.grade') }}{{ $t('public.colon') }}{{ classInfo.grade }}
        </span>
        <span>
          {{ $t('public.studentNumberO') }}{{ $t('public.colon')
          }}{{ classInfo.number }}
        </span>
      </div>

      <a-button type="primary" @click="editStudent">
        {{ $t('public.edit', { content: $t('public.class_lower') }) }}
      </a-button>
    </div>

    <!-- 表格 -->
    <a-table
      size="middle"
      :rowKey="record => record.id"
      :scroll="{ x: 1000 }"
      :loading="tableLoading"
      :dataSource="dataSource"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: selectChange
      }"
      :pagination="false"
    >
      <a-table-column
        :title="$t('public.studentId')"
        dataIndex="studentNo"
      ></a-table-column>

      <a-table-column :title="$t('public.name')" dataIndex="name">
        <template slot-scope="name, record">
          {{ record.name }} {{ record.surname }} {{ record.givenName }} ({{
            record.englishName
          }})
          <!-- <span
            class="name"
            :class="
              record.studentStatus == 3
                ? 'QS'
                : record.studentStatus == 4
                ? 'DO'
                : 'GRA'
            "
            v-if="
              record.studentStatus == 3 ||
                record.studentStatus == 4 ||
                record.studentStatus == 5
            "
            >{{
              record.studentStatus == 3
                ? $t('public.quitSchool')
                : record.studentStatus == 4
                ? $t('public.dropOut')
                : record.studentStatus == 5
                ? $t('public.graduation')
                : ''
            }}</span
          > -->
        </template>
      </a-table-column>

      <a-table-column
        :title="$t('public.dateOfBirth')"
        dataIndex="birthdate"
      ></a-table-column>

      <a-table-column
        :title="$t('public.enrollmentTime')"
        dataIndex="enrollDate"
      ></a-table-column>

      <a-table-column
        :title="$t('public.enrollmentGradeTitle')"
        dataIndex="enrollGrade"
      >
        <template slot-scope="enrollGrade">
          {{ enrollGrade | filteGrade('name') }}
        </template>
      </a-table-column>

      <a-table-column
        :title="$t('public.currentGrade')"
        dataIndex="currentGrade"
      >
        <template slot-scope="currentGrade">
          {{ currentGrade | filteGrade('name') }}
        </template>
      </a-table-column>
    </a-table>

    <!-- 编辑学生 -->
    <a-modal
      :title="$t('public.student')"
      v-model="modalVisible"
      :maskClosable="false"
      :width="800"
      :bodyStyle="{
        paddingTop: '12px',
        paddingBottom: 0
      }"
      :confirmLoading="modalLoading"
      @ok="ok"
      :afterClose="afterClose"
    >
      <a-form :form="form">
        <a-form-item
          label=""
          :labelCol="{ span: 0 }"
          :wrapperCol="{ span: 24 }"
        >
          <a-transfer
            showSearch
            :lazy="false"
            :listStyle="{
              height: '400px',
              width: '330px'
            }"
            :targetKeys="studentSelected"
            :dataSource="studentDataSource"
            :operations="[$t('handle.add'), $t('handle.delete')]"
            :titles="[$t('public.unselected'), $t('public.selected')]"
            :render="renderStudentItem"
            v-decorator="[
              'student',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseChoose', {
                      content: $t('public.student_lower')
                    })
                  }
                ]
              }
            ]"
            @change="studentChange"
          >
          </a-transfer>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      campusId: localStorage.getItem('campusId'),

      tableLoading: false,
      classInfo: {},
      dataSource: [],
      selectedRowKeys: [],

      // 编辑学生
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      studentSelected: [],
      studentDataSource: []
    }
  },

  props: {
    itemId: {
      default: ''
    }
  },

  created() {
    this.getClassesDetail()
    this.getStudentList()
  },

  methods: {
    // 班级详情
    getClassesDetail() {
      this.$http(this.$api.GETCLASSESDETAIL, {
        id: this.itemId
      }).then(r => {
        this.classInfo = r.data
        this.dataSource = r.data.students

        this.studentSelected = r.data.students.map(item => {
          return item.id.toString()
        })
      })
    },

    // 所有学生
    getStudentList() {
      this.$http(this.$api.GETSTUDENTLISTALL, {
        campusId: this.campusId
      }).then(r => {
        this.studentDataSource = r.data.map(item => {
          return {
            ...item,
            key: item.id.toString(),
            title: `${item.name} ${item.surname} ${item.givenName} (${item.englishName})`
          }
        })
      })
    },

    // 渲染学生
    renderStudentItem(item) {
      let student = null
      if (item.gender) {
        student = (
          <span>
            <span> {item.title} </span>{' '}
            <a-
              icon
              style={{
                'margin-left': '10px',
                'font-size': '20px',
                display: item.gender ? '' : 'none',
                color: this.$utils.filteGender(item.gender, 'color')
              }}
              type={this.$utils.filteGender(item.gender, 'icon')}
            />{' '}
          </span>
        )
      } else {
        student = <span> {item.title} </span>
      }

      return {
        label: student,
        value: item.title
      }
    },

    // 选中学生
    studentChange(targetKeys) {
      this.studentSelected = targetKeys
    },

    editStudent() {
      this.modalVisible = true
    },

    ok() {
      this.form.validateFields(err => {
        if (!err) {
          this.saveClassStudent()
        }
      })
    },

    saveClassStudent() {
      this.modalLoading = true

      const studentSelected = this.studentSelected.map(item => {
        return Number(item)
      })

      this.$http(this.$api.SAVECLASSSTUDENT, {
        campusId: this.campusId,
        classId: this.itemId,
        studentIds: JSON.stringify(studentSelected)
      })
        .then(() => {
          this.$message.success(this.$t('public.saveSuccess'))
          this.getClassesDetail()
          this.modalVisible = false
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    afterClose() {
      this.modalLoading = false
      this.selectedRowKeys = []
    },

    // 多选
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    }
  }
}
</script>

<style lang="less" scoped>
.the-class-roster {
  .class-info-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .class-info {
      display: flex;

      & > span {
        margin-right: 15px;
      }
    }
  }

  /deep/ .ant-table-tbody {
    .name {
      margin-left: 8px;
      display: inline-block;
      padding: 2px 3px;

      color: white;
      border-radius: 5px;
    }

    //休学
    // .QS {
    //   background-color: #ff9933;
    // }

    // //退学
    // .DO {
    //   background-color: #ff6666;
    // }

    // .GRA {
    //   background-color: #707070;
    // }
  }
}
</style>
